import { render, staticRenderFns } from "./create-promotion-overview.vue?vue&type=template&id=02ab16aa&scoped=true"
import script from "./create-promotion-overview.vue?vue&type=script&lang=js"
export * from "./create-promotion-overview.vue?vue&type=script&lang=js"
import style0 from "./create-promotion-overview.vue?vue&type=style&index=0&id=02ab16aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab16aa",
  null
  
)

export default component.exports